import { useMutation } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import type { Language, LanguageLabel } from '@/shared/types';
import { updateUserProfileSettings } from '../requests';
import type { UserProfileSettingsRequestDto } from '../types';

export const toPreferredLanguage = (language: Language): LanguageLabel =>
  language.toUpperCase() as LanguageLabel;

export function useUpdateUserProfileSettings() {
  const { session } = useSessionStore();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation<
    void,
    Error,
    UserProfileSettingsRequestDto
  >({
    mutationKey: ['user-profile-settings', session?.userId],
    mutationFn: updateUserProfileSettings,
  });

  return {
    isPending,
    isError,
    error,
    updateSettings: mutate,
    updateSettingsAsync: mutateAsync,
  };
}
